import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import edge_to_edge_parallel_svg from '../../../assets/img/SVG_icons/Top/editing_model/edge_to_edge_tangent_parallel.svg';
import { img } from '@phi/components';
import { make_edges_tangent_parallel_to_edge } from '@frontend/uid_continuity';
import EdgeToEdgeParallelTooltip from './EdgeToEdgeParallelTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const EdgeToEdgeParallelIcon = edge_to_edge_parallel_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Parallel edge tangent w.r.t. another edge';
        },

        disabled() {
            return !this.state.loaded
                || !this.state.editing_edge_tangent_mode
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || !this.two_or_more_edges_selected;
        },

        two_or_more_edges_selected() {
            return this.state.selected_edges_count >= 2
                && this.state.selected_faces_count === 0
                && this.state.selected_vertices_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                make_edges_tangent_parallel_to_edge();
        },
    },

    render() {
        return h(BarButton, {
            id: 'edge-to-edge-tangent-parallel-button',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 8,
            active: false,
            tippy: 'left',
            help: 'edge_to_edge_tangent_parallel',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edge_to_edge_parallel_svg, this.alt),
            tooltip: EdgeToEdgeParallelTooltip,
        });
    },
});
